import Badge from "@/common/components/Badge";
import Box from "@/common/components/Box";
import {
  formatCurrency,
  formatDecimal,
  formatUnit,
} from "@/common/utils/formatters";
import { FileBoxIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { NegotiationProductData } from "../../types/negotiations.type";
import NegotiationProductHistoriesModal from "./NegotiationProductHistoriesModal";
import { negotiationProductValueLabelByStatus } from "../../constants/negotiationStatus.constant";
import { CompanyData } from "@/features/privateCompanies/types/companies.type";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import ButtonLink from "@/common/components/ButtonLink";

interface NegotiatingProductItemProps {
  index: number;
  negotiationProduct: NegotiationProductData;
  clientCompany?: CompanyData;
  establishment?: EstablishmentCompanyData;
}

const NegotiatingProductItemShow = ({
  negotiationProduct,
  clientCompany,
  establishment,
}: NegotiatingProductItemProps) => {
  return (
    <Box
      className={twMerge(
        "flex flex-col gap-3",
        negotiationProduct.status === "accepted" && "bg-success-op",
        negotiationProduct.status === "rejected" && "bg-danger-op",
        negotiationProduct.status === "pending" && "bg-yellow-op-2",
      )}
    >
      <div className="flex items-center gap-2">
        <ButtonLink
          linkTo={`/products/${negotiationProduct.product.id}`}
          operationKlassToCheckPermission="Admin::Products::Show"
          hoverBackgroundSize="small"
        >
          <Badge
            Icon={FileBoxIcon}
            iconProps={{ size: 20, strokeWidth: 1.5 }}
            text={negotiationProduct.product.display_name}
            className="rounded-sm flex bg-neutral-op-8 w-fit flex-row-reverse overflow-hidden !p-0 gap-0"
            overwriteClassName
            contentClassName="px-3 py-2"
          />
        </ButtonLink>
      </div>

      <div className="flex flex-col gap-2">
        <Box className="rounded-xl flex items-end justify-between px-4 py-5">
          <div className="flex flex-col gap-1">
            <p className="text-xs font-light">
              {
                negotiationProductValueLabelByStatus[
                  negotiationProduct.status || "pending"
                ]
              }
            </p>

            <p className="text-sm font-medium">
              {formatUnit(
                formatCurrency(Number(negotiationProduct.value)),
                negotiationProduct.product.unit_for_quantity,
              )}
            </p>
          </div>
        </Box>

        <Box className="rounded-xl flex items-end justify-between px-4 py-5">
          <div className="flex flex-col gap-1">
            <p className="text-xs font-light">Estimativa de consumo mensal</p>

            <p className="text-sm font-medium">
              {formatUnit(
                formatDecimal(negotiationProduct.quantity, 0),
                negotiationProduct.product.unit_for_quantity,
              )}
              /Mês
            </p>
          </div>
        </Box>
      </div>

      <NegotiationProductHistoriesModal
        product={negotiationProduct.product}
        clientCompany={clientCompany}
        establishment={establishment}
        negotiationProductId={negotiationProduct.id}
      />
    </Box>
  );
};

export default NegotiatingProductItemShow;
